import { useEffect } from 'react';
import { captureInitialVisitAttribution } from '@/lib/leadAttribution';

/** Runs once per full page load to persist HTTP referrer before analytics consent. */
export default function LeadAttributionBootstrap() {
  useEffect(() => {
    captureInitialVisitAttribution();
  }, []);
  return null;
}
